export const SHOWING_TEXT = 'Showing';
export const OF_TEXT = 'of';
export const ITEMS_TEXT = 'items';
export const PAGES_TEXT = 'pages';
export const PAGE_SIZE_LABEL = 'Items Per Page:';
export const PAGE_NUMBER_LABEL = 'Page Number';
export const BREAKPOINT = 768;
